import { Fragment, useContext, useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Text,
  Input,
  Container,
  useColorMode,
  HStack,
  VStack,
  Image,
  Link,
  Button,
  Tabs,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Flex,
  Divider,
  useToast,
  InputGroup,
  InputLeftAddon,
  Alert,
  AlertIcon,
  Progress,
  Badge,
} from '@chakra-ui/react';
import axios from 'axios';
import { Dropzone, FileItem } from '@dropzone-ui/react';
import { useMultiState } from '../lib/hooks';
import { useMutation, useQuery } from '@apollo/client';
import subjectQuery from '../graphql/queries/subject';
import StudentOfSubjectMutation from '../graphql/mutations/createStudentOfSubject';
import studentofsubjectupdate from '../graphql/mutations/updateStudentOfSubject';
import studentofsubjectsQueries from '../graphql/queries/studentofsubject';
import studentofsubjectsRemoveMutation from '../graphql/mutations/removeStudentofSubject';
import configforumbyID from '../graphql/queries/configforumbyID';
import progressbyscore from '../graphql/queries/progress';
import subjectProgressQuery from '../graphql/queries/subjectProgress';
import progressUpdate from '../graphql/mutations/createProgress';
import Certificate from '../graphql/queries/certificate';
import { useParams } from 'react-router';
import OneSubjectLayoutSkeleton from '../components/skeleton/OneSubjectLayoutSkeleton';
import draftToHtml from 'draftjs-to-html';
import renderHTML from 'react-render-html';
import { useHistory } from 'react-router';
import Iframe from 'react-iframe';
import AuthContext from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Link as domlink } from 'react-router-dom';
import SubjectCard from '../components/pages/SubjectPage/SubjectCard';
import DialogEnrollSubject from '../components/pages/SubjectPage/DialogEnrollSubject';
import DialogUnEnrollSubject from '../components/pages/SubjectPage/DialogUnEnrollSubject';
import ContentCard from '../components/pages/SubjectPage/ContentCard';

import dayjs from 'dayjs';
import { convertFormToAnswers } from '../lib/convertFormAnswer';

require('dayjs/locale/th');
require('dayjs/locale/en');

var localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);

const URLImage = process.env.REACT_APP_UPLOAD_IMAGE;

const SubjectPage = () => {
  const myCurrentDate = new Date();

  const { t } = useTranslation();
  const { colorMode } = useColorMode();
  const { user } = useContext(AuthContext);
  const params = useParams();
  const toast = useToast();
  const history = useHistory();
  const [formQuestionare, setFormQuestionare] = useState({
    firstName: '',
    lastName: '',
    gender: '',
    birthDate: '',
    status: '',
    education: '',
    department: '',
    position: '',
    roles: [],
    otherRole: '',
    healthZone: '',
    province: '',
    district: '',
    subDistrict: '',
    fund: '',
    fundTypes: [],
  });
  const [enrollState, setEnrollState] = useMultiState({
    certificatestatus: false,
    creditstatus: false,
    name: '',
    _id: '',
  });

  const [modalDisplay, setModalDisplay] = useMultiState({ name: '', type: '', link: '', doctype: '' });
  const [contentState, setContentState] = useState();
  const [progressState, setProgressState] = useState();
  const [updatePayState, setUpdatePayState] = useState();

  const [categorizedContent, setCategorizedContent] = useState({
    video: [],
    document: [],
    link: [],
    homework: [],
    quiz: [],
    survey: [],
  });

  const { isOpen: ModalState, onOpen: openModal, onClose: closeModal } = useDisclosure();
  const { isOpen: PayModalState, onOpen: openPayModal, onClose: closePayModal } = useDisclosure();
  const {
    isOpen: dialogEnrollSubjectToggle,
    onOpen: openDialogEnrollSubject,
    onClose: closeDialogEnrollSubject,
  } = useDisclosure();
  const {
    isOpen: dialogUnEnrollSubjectToggle,
    onOpen: openDialogUnEnrollSubject,
    onClose: closeDialogUnEnrollSubject,
  } = useDisclosure();

  const [setStudentOfSubjectMutation] = useMutation(StudentOfSubjectMutation);
  const [setstudentofsubjectsRemoveMutation] = useMutation(studentofsubjectsRemoveMutation);
  const [setStudentofsubjectUpdateMutation] = useMutation(studentofsubjectupdate);
  const [setUpdateProgress] = useMutation(progressUpdate);

  const [filesImg, setFilesImg] = useState([]);
  const [newphotoData, setnewphotoData] = useMultiState({
    data: null,
    base64: '',
  });

  const onDeleteImg = (id) => {
    setFilesImg(filesImg.filter((x) => x.id !== id));
  };

  const {
    data: subjectData,
    refetch: refetchSubject,
    loading,
  } = useQuery(
    subjectQuery,
    {
      variables: {
        _id: params?.subjectId,
      },
    },
    { fetchPolicy: 'network-only' }
  );

  const { data: responseForum, refetch: refetchForumData } = useQuery(
    configforumbyID,
    {
      variables: {
        _id: params?.subjectId,
      },
    },
    { fetchPolicy: 'network-only' }
  );

  const { data: responseStudentEnroll, refetch: refetchStudentEnroll } = useQuery(
    studentofsubjectsQueries,
    {
      variables: {
        subject: params?.subjectId,
        student: user?._id ? user?._id : null,
      },
    },
    { fetchPolicy: 'network-only' }
  );

  const { data: progressvalue } = useQuery(
    progressbyscore,
    {
      variables: {
        student: user?._id ? user?._id : null,
      },
    },
    { fetchPolicy: 'network-only' }
  );

  const { data: certificate, refetch: refetchCertificate } = useQuery(
    Certificate,
    {
      variables: {
        subject: params?.subjectId,
        student: user?._id ? user?._id : null,
      },
    },
    { fetchPolicy: 'network-only' }
  );

  const { data: subjectProgressData, refetch: refetchSubjectProgress } = useQuery(
    subjectProgressQuery,
    {
      variables: {
        subjectId: params?.subjectId,
        studentId: user?._id ? user?._id : 'guest',
      },
      skip: !user?._id,
    },
    { fetchPolicy: 'network-only' }
  );
  console.log("🚀 ~ SubjectPage ~ subjectProgressData:", subjectProgressData?.subjectProgress)

  useEffect(() => {
    if (progressvalue) {
      setProgressState(progressvalue);
    }
    if (certificate) {
      setEnrollState(certificate?.studentofsubject);
    }
    if (responseStudentEnroll) {
      setUpdatePayState(responseStudentEnroll?.studentofsubject?._id);
    }
  }, [progressvalue, certificate]);

  const getSortedContents = (contents = [], sorting = []) => {
    const contentList = contents || [];
    if (!Array.isArray(sorting) || sorting.length === 0) return contentList;

    const contentById = new Map(contentList.map((content) => [content?._id, content]));
    const sortedContents = sorting.map((contentId) => contentById.get(contentId)).filter(Boolean);
    const sortedIds = new Set(sortedContents.map((content) => content?._id));
    const unsortedContents = contentList.filter((content) => content?._id && !sortedIds.has(content._id));

    return [...sortedContents, ...unsortedContents];
  };

  useEffect(async () => {
    if (subjectData) {
      const sortedContent = getSortedContents(subjectData?.subject?.contents, subjectData?.subject?.sorting);
      setContentState(sortedContent);

      const categorized = {
        video: [],
        document: [],
        link: [],
        homework: [],
        quiz: [],
        survey: [],
      };

      sortedContent?.forEach((content) => {
        if (categorized[content.type]) {
          categorized[content.type].push(content);
        }
      });

      setCategorizedContent(categorized);
    }
  }, [subjectData, enrollState]);

  const handleSubmitEnrollSubject = async (e) => {
    e.preventDefault();
    try {
      let answers = [];
      if (subjectData?.subject?.questionnaire) {
        if (
          !formQuestionare.firstName ||
          !formQuestionare.gender ||
          !formQuestionare.birthDate ||
          !formQuestionare.status ||
          !formQuestionare.education ||
          !formQuestionare.department ||
          !formQuestionare.position ||
          (formQuestionare.roles.length === 0 && !formQuestionare.otherRole) ||
          !formQuestionare.healthZone ||
          !formQuestionare.province ||
          !formQuestionare.district ||
          !formQuestionare.subDistrict ||
          !formQuestionare.fund ||
          (formQuestionare.fundTypes.length === 0 && !formQuestionare.otherFundType)
        ) {
          const missingFields = [];
          if (!formQuestionare.firstName) missingFields.push('ชื่อ');
          if (!formQuestionare.gender) missingFields.push('เพศ');
          if (!formQuestionare.birthDate) missingFields.push('วันเกิด');
          if (!formQuestionare.status) missingFields.push('สถานะ');
          if (!formQuestionare.education) missingFields.push('การศึกษา');
          if (!formQuestionare.department) missingFields.push('แผนก');
          if (!formQuestionare.position) missingFields.push('ตำแหน่ง');
          if (formQuestionare.roles.length === 0 && !formQuestionare.otherRole) missingFields.push('บทบาท');
          if (!formQuestionare.healthZone) missingFields.push('เขตสุขภาพ');
          if (!formQuestionare.province) missingFields.push('จังหวัด');
          if (!formQuestionare.district) missingFields.push('อำเภอ');
          if (!formQuestionare.subDistrict) missingFields.push('ตำบล');
          if (!formQuestionare.fund) missingFields.push('กองทุน');
          if (formQuestionare.fundTypes.length === 0 && !formQuestionare.otherFundType)
            missingFields.push('ประเภทกองทุน');

          if (missingFields.length > 0) {
            toast({
              position: 'top',
              title: 'กรุณากรอกข้อมูลให้ครบ',
              description: `ข้อมูลที่ขาด: ${missingFields.join(', ')}`,
              status: 'error',
              duration: 5000,
              isClosable: true,
            });
            return;
          }
          return;
        }
        answers = convertFormToAnswers(formQuestionare);
      }
      const { data: enrollData } = await setStudentOfSubjectMutation({
        variables: {
          subject: subjectData?.subject?._id,
          student: user?._id,
          certificatestatus: enrollState?.certificatestatus,
          creditstatus: enrollState?.creditstatus,
          name: enrollState?.certificatestatus ? enrollState?.name : '',
          answers: answers,
        },
      });
      if (enrollData) {
        await toast({
          position: 'top',
          title: 'Success',
          description: `${t('subjectPage.alertAddComplete')}`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        refetchPage();
      }
      closeDialogEnrollSubject();
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdatePayment = async (e) => {
    e.preventDefault();
    try {
      const responseImage = await axios.post(URLImage, {
        photo: newphotoData?.base64,
      });
      const { data: responseContent } = await setStudentofsubjectUpdateMutation({
        variables: {
          _id: updatePayState,
          payment_image: responseImage ? responseImage?.data?.url : '',
        },
      });
      if (responseContent) {
        await toast({
          position: 'top',
          title: 'Success',
          description: `${t('subjectPage.alertAddComplete')}`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        refetchPage();
      }
      closeDialogEnrollSubject();
    } catch (error) {
      console.error(error);
    }
  };

  //Alert dialog remove Enroll
  const handleSubmitUnEnrollSubject = async (e) => {
    e.preventDefault();
    try {
      const { data: enrollData } = await setstudentofsubjectsRemoveMutation({
        variables: {
          _id: certificate?.studentofsubject?._id,
        },
      });
      if (enrollData) {
        await toast({
          position: 'top',
          title: 'Success',
          description: `${t('subjectPage.alertDeleteComplete')}`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        refetchPage();
      }
      closeDialogUnEnrollSubject();
    } catch (error) {
      console.error(error);
    }
  };

  const handleConvertHTML = (text) => {
    if (text) {
      return renderHTML(draftToHtml(text));
    }
    return '';
  };

  const handleUpdateProgress = async (content, progress) => {
    try {
      const { data: ProgressData } = await setUpdateProgress({
        variables: {
          content: content?._id,
          student: user?._id,
          progress: progress,
          path: window.location.href,
        },
      });
      if (ProgressData) {
        console.log(ProgressData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const alertJoincourse = () => {
    return toast({
      position: 'top',
      title: 'warning',
      description: `${t('subjectPage.textwarning')}`,
      status: 'warning',
      duration: 3000,
      isClosable: true,
    });
  };

  const getProgressValue = (contentId, key = 'certificateProgress') => {
    const progressItem = progressState?.progresss?.find((percen) => percen?.content?._id === contentId);
    if (!progressItem) return 0;
    const progress = Number(progressItem.progress) || 0;
    const zoomprogress = Number(progressItem.zoomprogress) || 0;
    return Number(progressItem[key] ?? Math.max(progress, zoomprogress)) || 0;
  };

  const getContentGroupProgress = (contents = []) => {
    const activeContents = contents.filter((content) => content?.statusActive);
    if (activeContents.length === 0) {
      return { total: 0, completed: 0, percent: 0 };
    }

    const completed = activeContents.filter((content) => getProgressValue(content?._id) >= 100).length;
    return {
      total: activeContents.length,
      completed,
      percent: Math.round((completed / activeContents.length) * 100),
    };
  };

  const groupedContent = [...(subjectData?.subject?.contentGroups || [])]
    .sort((a, b) => (a.index || 0) - (b.index || 0))
    .map((group) => ({
      ...group,
      contents: (contentState || []).filter((content) => {
        const groupId = content?.contentGroup?._id || content?.contentGroup;
        return groupId === group._id;
      }),
    }));

  const ungroupedContents = (contentState || []).filter((content) => !content?.contentGroup?._id && !content?.contentGroup);
  const enableLegacySubjectCertificate = false;

  const updateFilesImg = (incommingFiles, e) => {
    if (incommingFiles.length !== 0) {
      new Promise((resolve, reject) => {
        setFilesImg(incommingFiles);
        setnewphotoData({ data: incommingFiles[0]?.file });
        const reader = new FileReader();
        reader.readAsDataURL(incommingFiles[0]?.file);
        reader.onload = () => {
          resolve(reader.result);
          setnewphotoData({
            base64: reader.result,
          });
        };
        reader.onerror = (error) => reject(error);
      });
    }
  };

  const refetchPage = () => {
    refetchCertificate({
      subject: params?.subjectId,
      student: user?._id,
    });
    refetchSubject({
      _id: params?.subjectId,
    });
    refetchForumData({
      _id: params?.subjectId,
    });
    refetchStudentEnroll({
      subject: params?.subjectId,
      student: user?._id,
    });
    if (user?._id) {
      refetchSubjectProgress({
        subjectId: params?.subjectId,
        studentId: user?._id,
      });
    }
  };

  const renderContentByType = (contents, type) => {
    if (contents.length === 0) {
      return (
        <Box w='full' p={'2'} boxShadow='lg' borderRadius={'lg'} h={'200'} bg={'gray.100'}>
          <Flex direction={'column'} alignItems={'center'} justifyContent={'center'} style={{ height: '100%' }}>
            <Text fontSize={'35'} color={'gray.500'}>
              {t('subjectPage.text_no_content')}
            </Text>
          </Flex>
        </Box>
      );
    }

    return contents?.map((content, i) => {
      const progresspercen = progressState?.progresss?.find((percen) => percen?.content?._id === content?._id);
      return (
        <Box key={content?._id}>
          {content?.expiredate === null ||
          dayjs(myCurrentDate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') <
            dayjs(content?.expiredate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') ||
          dayjs(myCurrentDate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') >
            dayjs(content?.expiredate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') ? (
            <Box>
              {content?.statusActive && (
                <ContentCard
                  index={i}
                  name={content?.name}
                  content={content}
                  carddescription={content?.carddescription}
                  progress={progresspercen?.progress ? progresspercen?.progress : 0}
                  subjectId={params?.subjectId}
                  enroll={responseStudentEnroll?.studentofsubject}
                  alertJoincourse={alertJoincourse}
                  handleUpdateProgress={handleUpdateProgress}
                  user={user}
                  setModalDisplay={setModalDisplay}
                  openModal={openModal}
                />
              )}
            </Box>
          ) : null}
        </Box>
      );
    });
  };

  return (
    <Fragment>
      <Modal size={'full'} isOpen={ModalState} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {modalDisplay?.name}{' '}
            {modalDisplay?.type === 'document' && (
              <Link href={`${modalDisplay?.link}`} isExternal>
                {' '}
                <ExternalLinkIcon ml={2} />
              </Link>
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Iframe src={modalDisplay?.link} width={'100%'} height={'600px'} display='initial' position='relative' />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={PayModalState} onClose={closePayModal} size={'3xl'}>
        <ModalOverlay />
        <form onSubmit={handleUpdatePayment}>
          <ModalContent>
            <ModalHeader>{t('subjectPage.payment')}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <HStack spacing='5vh'>
                {enrollState?.payment_image && (
                  <Image boxSize='50vh' src={enrollState?.payment_image} alt='Dan Abramov' />
                )}

                <Dropzone onChange={updateFilesImg} value={filesImg} accept='image/*' maxFiles='1' view='grid'>
                  {filesImg.map((file) => (
                    <FileItem
                      {...file}
                      key={file.id}
                      onDelete={onDeleteImg}
                      //localization={"EN-en"}
                      //resultOnTooltip
                      preview={true}
                    />
                  ))}
                </Dropzone>
              </HStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={closePayModal}>
                {t('Button.close')}
              </Button>
              <Button variant='ghost' type='submit'>
                {t('Button.submit')}
              </Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>

      <Container maxW={'7xl'} px={[50]} mt={10}>
        {loading ? (
          <OneSubjectLayoutSkeleton />
        ) : (
          <>
            <SubjectCard
              openDialogUnEnrollSubject={openDialogUnEnrollSubject}
              openDialogEnrollSubject={openDialogEnrollSubject}
              enroll={responseStudentEnroll?.studentofsubject}
              subjectData={subjectData}
              user={user}
            />

            {/* Subject Progress Bar */}
            {user?._id && responseStudentEnroll?.studentofsubject && subjectProgressData?.subjectProgress && (
              <Box
                mt={4}
                p={4}
                borderRadius='lg'
                bg={colorMode === 'light' ? 'white' : 'gray.700'}
                boxShadow='md'
                borderWidth='1px'
              >
                <Flex justify='space-between' align='center' mb={2}>
                  <HStack spacing={3}>
                    <Heading as='h5' size='sm'>
                      ความคืบหน้ารวมของรายวิชา
                    </Heading>
                    <Badge
                      colorScheme={
                        subjectProgressData.subjectProgress.progressPercent === 100
                          ? 'green'
                          : subjectProgressData.subjectProgress.progressPercent >= 50
                          ? 'blue'
                          : 'orange'
                      }
                      fontSize='sm'
                      px={2}
                      py={1}
                      borderRadius='md'
                    >
                      {Math.round(subjectProgressData.subjectProgress.progressPercent)}%
                    </Badge>
                  </HStack>
                  <Text fontSize='sm' color='gray.500'>
                    {subjectProgressData.subjectProgress.completedContents} / {subjectProgressData.subjectProgress.totalContents} เนื้อหา
                  </Text>
                </Flex>
                <Progress
                  value={subjectProgressData.subjectProgress.progressPercent}
                  size='md'
                  borderRadius='full'
                  colorScheme={
                    subjectProgressData.subjectProgress.progressPercent === 100
                      ? 'green'
                      : subjectProgressData.subjectProgress.progressPercent >= 50
                      ? 'blue'
                      : 'orange'
                  }
                  hasStripe={subjectProgressData.subjectProgress.progressPercent < 100}
                  isAnimated={subjectProgressData.subjectProgress.progressPercent < 100}
                />
                {subjectProgressData.subjectProgress.progressPercent === 100 && (
                  <Text mt={2} fontSize='sm' color='green.500' fontWeight='bold'>
                    🎉 เรียนครบทุกเนื้อหาแล้ว!
                  </Text>
                )}
              </Box>
            )}

            <Box mt='5' minHeight={'60vh'}>
              <Tabs size='md' variant='enclosed'>
                <TabList>
                  <Tab>{t('subjectPage.content')}</Tab>
                  <Tab>{t('subjectPage.tab_labels.prepost_test')}</Tab>
                  <Tab>{t('subjectPage.tab_labels.training_content')}</Tab>
                  <Tab>{t('subjectPage.tab_labels.additional_content')}</Tab>
                  <Tab>{t('subjectPage.tab_labels.documents')}</Tab>
                  <Tab>{t('subjectPage.tab_labels.homework')}</Tab>
                  {/* <Tab>{t('subjectPage.tab_labels.quizzes')}</Tab> */}
                  {/* {user?.role === 'TEACHER' || user?.role === 'ADMIN' ? (
                    <Tab>{t('subjectPage.forum')}</Tab>
                  ) : (
                    <>
                      {user && responseStudentEnroll ? (
                        <Tab>{t('subjectPage.forum')}</Tab>
                      ) : (
                        <Tab isDisabled>{t('subjectPage.forum')}</Tab>
                      )}
                    </>
                  )} */}
                  {enableLegacySubjectCertificate && certificate?.studentofsubject?.certificatestatus && <Tab>{t('subjectPage.status')}</Tab>}
                </TabList>
                <TabPanels>
                  <TabPanel>
                    {/* <Box py={'10'}>
                      <Heading as='h4' size='md'>
                        {`${subjectData?.subject?.name}`}
                      </Heading>
                      <Text py={'4'}>{subjectData?.subject?.description}</Text>
                    </Box> */}
                    <Heading as='h4' size='md'>
                      {t('subjectPage.content')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {contentState?.length == 0 ? (
                        <Box w='full' p={'2'} boxShadow='lg' borderRadius={'lg'} h={'200'} bg={'gray.100'}>
                          <Flex
                            direction={'column'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            style={{ height: '100%' }}
                          >
                            <Text fontSize={'35'} color={'gray.500'}>
                              {t('subjectPage.text_no_content')}
                            </Text>
                          </Flex>
                        </Box>
                      ) : (
                        <VStack align='stretch' spacing={5}>
                          {[...groupedContent, ...(ungroupedContents.length ? [{ _id: 'ungrouped', name: 'เนื้อหาที่ยังไม่จัดกลุ่ม', contents: ungroupedContents }] : [])].map(
                            (group) => {
                              const groupProgress = getContentGroupProgress(group.contents);
                              return (
                                <Box key={group._id} borderWidth='1px' borderRadius='lg' p={4} bg={colorMode === 'light' ? 'white' : 'gray.700'}>
                                  <Flex justify='space-between' align={['stretch', 'center']} direction={['column', 'row']} gap={3} mb={3}>
                                    <Box>
                                      <Heading as='h5' size='sm'>
                                        {group.name}
                                      </Heading>
                                      {group.description && (
                                        <Text fontSize='sm' color='gray.500'>
                                          {group.description}
                                        </Text>
                                      )}
                                    </Box>
                                    <HStack>
                                      <Badge colorScheme={groupProgress.percent >= 100 ? 'green' : 'blue'}>
                                        {groupProgress.percent}%
                                      </Badge>
                                      <Text fontSize='sm' color='gray.500'>
                                        {groupProgress.completed} / {groupProgress.total} เนื้อหา
                                      </Text>
                                      {group._id !== 'ungrouped' && group.certificateconfig?.status && groupProgress.percent >= 100 && (
                                        <Button
                                          as={domlink}
                                          to={`/content-group-certificate/${group._id}`}
                                          size='sm'
                                          colorScheme='green'
                                          variant='outline'
                                        >
                                          Download Certificate
                                        </Button>
                                      )}
                                    </HStack>
                                  </Flex>
                                  <Progress value={groupProgress.percent} size='sm' borderRadius='full' colorScheme={groupProgress.percent >= 100 ? 'green' : 'blue'} mb={3} />
                                  {group.contents?.map((content, i) => {
                                    const progresspercen = progressState?.progresss?.find(
                                      (percen) => percen?.content?._id === content?._id
                                    );
                                    return (
                                      <Box key={content?._id}>
                                        {content?.expiredate === null ||
                                        dayjs(myCurrentDate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') <
                                          dayjs(content?.expiredate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') ||
                                        dayjs(myCurrentDate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') >
                                          dayjs(content?.expiredate).format('วันที่ DD/MM/YYYY , เวลา HH:mm:ss') ? (
                                          <Box>
                                            {content?.statusActive && (
                                              <ContentCard
                                                index={i}
                                                name={content?.name}
                                                content={content}
                                                carddescription={content?.carddescription}
                                                progress={progresspercen?.progress ? progresspercen?.progress : 0}
                                                subjectId={params?.subjectId}
                                                enroll={responseStudentEnroll?.studentofsubject}
                                                alertJoincourse={alertJoincourse}
                                                handleUpdateProgress={handleUpdateProgress}
                                                user={user}
                                                setModalDisplay={setModalDisplay}
                                                openModal={openModal}
                                              />
                                            )}
                                          </Box>
                                        ) : null}
                                      </Box>
                                    );
                                  })}
                                </Box>
                              );
                            }
                          )}
                        </VStack>
                      )}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md' mb={4}>
                      {t('subjectPage.tab_labels.all_prepost_tests')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {renderContentByType(categorizedContent.survey, 'survey')}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md' mb={4}>
                      {t('subjectPage.tab_labels.all_training_content')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {renderContentByType(categorizedContent.video, 'video')}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md' mb={4}>
                      {t('subjectPage.tab_labels.all_additional_content')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {renderContentByType(categorizedContent.link, 'link')}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md' mb={4}>
                      {t('subjectPage.tab_labels.all_documents')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {renderContentByType(categorizedContent.document, 'document')}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md' mb={4}>
                      {t('subjectPage.tab_labels.all_homework')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {renderContentByType(categorizedContent.homework, 'homework')}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md' mb={4}>
                      {t('subjectPage.tab_labels.all_quizzes')}
                    </Heading>
                    <Box py={'2'}>
                      <Divider size={'lg'} />
                    </Box>
                    <Box p={'4'} borderRadius='lg'>
                      {renderContentByType(categorizedContent.quiz, 'quiz')}
                    </Box>
                  </TabPanel>

                  <TabPanel>
                    <Heading as='h4' size='md'>
                      {t('subjectPage.forum')}
                    </Heading>
                    <Box py={'2'} w={'100%'} mb={6}>
                      <Divider size={'lg'} orientation='horizontal' />
                    </Box>
                    {responseForum?.configforums.length === 0 ? (
                      <Text fontSize={'20'} color={'gray.500'}>
                        {t('subjectPage.alt')}
                      </Text>
                    ) : (
                      <Box borderWidth={'1px'}>
                        <Box bg={colorMode === 'light' ? 'brand.100' : 'brand.700'} p={3} mb={2}>
                          <Heading as='h4' size='md'>
                            {' '}
                            {t('subjectPage.title')}{' '}
                          </Heading>
                        </Box>
                        <Box>
                          {responseForum?.configforums?.map((forum) => (
                            <Box key={forum?._id} ml={3}>
                              <Link href={`/forum/${subjectData?.subject?._id}/${forum?._id}`} isExternal>
                                <Text color={'primary.700'}>{forum?.name}</Text>
                              </Link>
                              <Text>
                                {t('subjectPage.by')}
                                <Link
                                  color={'primary.700'}
                                  href={`/showprofile/${subjectData?.subject?.teacher?._id}`}
                                  isExternal
                                >
                                  {' '}
                                  {`${subjectData?.subject?.teacher?.firstname} ${subjectData?.subject?.teacher?.lastname}`}{' '}
                                </Link>
                                {dayjs(forum?.updatedAt).format(' DD MMMM YYYY , เวลา HH:mm:ss')}
                              </Text>
                              <Box py={'2'}>
                                <Divider orientation='horizontal' size={'xl'} />
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </TabPanel>

                  {enableLegacySubjectCertificate && certificate?.studentofsubject?.certificatestatus && (
                    <TabPanel>
                      <Heading as='h4' size='md'>
                        {t('subjectPage.status')}
                      </Heading>
                      <Box py={'2'} w={'100%'} mb={6}>
                        <Divider size={'lg'} orientation='horizontal' />
                      </Box>
                      <Box bg={colorMode === 'light' ? 'gray.200' : 'brand.600'} p={'5'} borderRadius={'lg'} mt={5}>
                        <HStack justify={'space-between'}>
                          <InputGroup size='lg' py={'2'}>
                            <InputLeftAddon
                              children={t('subjectPage.name')}
                              bg={colorMode === 'light' ? 'gray.100' : 'brand.800'}
                              color={colorMode === 'light' ? 'gray.800' : 'white'}
                            />
                            <Input
                              value={certificate?.studentofsubject?.name}
                              bg={colorMode === 'light' ? 'gray.300' : 'brand.500'}
                              isReadOnly
                            />
                          </InputGroup>
                          <InputGroup size='lg' py={'2'}>
                            <InputLeftAddon
                              children={t('subjectPage.status')}
                              bg={colorMode === 'light' ? 'gray.100' : 'brand.800'}
                              color={colorMode === 'light' ? 'gray.800' : 'white'}
                            />
                            {certificate?.studentofsubject?.status == 'disapproved' ? (
                              <Alert status='warning' variant='left-accent'>
                                <AlertIcon />
                                {t('subjectPage.disapproved')}
                              </Alert>
                            ) : (
                              <Alert status='success' variant='left-accent'>
                                <AlertIcon />
                                {t('subjectPage.approved')}
                              </Alert>
                            )}
                          </InputGroup>
                        </HStack>
                        {certificate?.studentofsubject?.status == 'approved' && (
                          <Box w='full' py={'2'}>
                            <Button
                              as={domlink}
                              to={`/certificate/${certificate?.studentofsubject?._id}`}
                              w='full'
                              bg={'green.300'}
                              boxShadow={'lg'}
                            >
                              Download
                            </Button>
                          </Box>
                        )}
                      </Box>
                      {subjectData?.subject?.course_certificate && (
                        <>
                          <Heading as='h4' size='md' mb={3}>
                            {t(' Payment ')}
                          </Heading>
                          <Box bg={colorMode === 'light' ? 'gray.200' : 'brand.600'} p={'5'} borderRadius={'lg'}>
                            <HStack justify={'space-between'} py={2}>
                              <Text>{handleConvertHTML(subjectData?.subject?.pay_description)}</Text>
                            </HStack>
                            {subjectData?.subject?.pay_certificate && (
                              <Button onClick={openPayModal}>{t('subjectPage.slip')}</Button>
                            )}
                          </Box>
                        </>
                      )}
                    </TabPanel>
                  )}
                </TabPanels>
              </Tabs>
            </Box>
          </>
        )}
      </Container>

      <DialogEnrollSubject
        dialogEnrollSubjectToggle={dialogEnrollSubjectToggle}
        closeDialogEnrollSubject={closeDialogEnrollSubject}
        handleSubmitEnrollSubject={handleSubmitEnrollSubject}
        formQuestionare={formQuestionare}
        setFormQuestionare={setFormQuestionare}
        subjectData={subjectData?.subject}
        enrollState={enrollState}
        setEnrollState={setEnrollState}
      />

      <DialogUnEnrollSubject
        handleSubmitUnEnrollSubject={handleSubmitUnEnrollSubject}
        dialogUnEnrollSubjectToggle={dialogUnEnrollSubjectToggle}
        closeDialogUnEnrollSubject={closeDialogUnEnrollSubject}
      />
    </Fragment>
  );
};

export default SubjectPage;
